module.exports = __webpack_public_path__ + "static/media/empty-vulns.1b2994f2.png";